const getElementPositionY = (selector: string) => {
  const el = document.querySelector(selector);
  return el?.getBoundingClientRect().y;
};

export const position = {
  getPositionYByElement: (selector: string) => getElementPositionY(selector),
};
